export default {
  // Constructor de encuestas: secciones, imagen y lógica de saltos
  untitled_question: 'Pregunta sin título',
  untitled_section: 'Sección sin título',
  section_description_placeholder: 'Descripción del título',
  attach_image_to_question: 'Adjuntar una imágen a la pregunta:',
  attach_photo: 'Adjuntar foto',
  no_image_attached: 'Sin imagen adjunta',
  image_attached: 'Imagen adjuntada',
  add_image: 'Agregar imagen',
  remove_image: 'Quitar imagen',
  add_section: 'Agregar sección',
  add_section_below: 'Agregar sección abajo',
  add_question_to_section: 'Agregar pregunta a esta sección',
  clone_section: 'Clonar sección',
  delete_section: 'Eliminar sección',
  select_question: 'Selecciona una pregunta',
  show_if_answer_is: 'Mostrar si la respuesta es',
  add_rule: 'Agregar regla',
  jump_next: 'Siguiente pregunta',
  jump_question: 'Seleccionar otra pregunta en esta misma sección',
  jump_section: 'Cambiar de sección',
  jump_submit: 'Enviar encuesta',
  jump_question_option: 'Pregunta {number} ({name})',
  jump_section_option: 'Sección {number} ({name})',
  jump_help_review: 'Por cada opción de respuesta de este ítem defines {what}.',
  jump_help_review_what: 'qué debe pasar a continuación',
  jump_help_action: 'Selecciona a dónde ir: {next}, {question}, {section} o {submit}.',
  jump_help_target: 'Si eliges {question} o {section}, indica la pregunta o la sección a la que debe saltar.',
  location_mode_manual: 'Permitir elegir una ubicación',
  location_mode_auto: 'Geolocalización automática',

  // Catálogo de tipos de ítem — constructor de encuestas (NewItem.vue, components/surveys/)
  build: {
    'form-checkbox': 'Casillas',
    'form-yes-no': 'Sí/No/NA',
    'form-option': 'Opción Múltiple',
    'form-select': 'Desplegable',
    'form-matrix': 'Matriz',
    'form-input-text': 'Respuesta Corta',
    'form-textarea': 'Respuesta Larga',
    'form-input-email': 'Correo electrónico',
    'form-input-number': 'Campo numérico',
    'form-date': 'Fecha',
    'form-hour': 'Hora',
    'form-satisfaction': 'Satisfacción',
    'form-rating': 'Calificación',
    'form-nps': 'NPS',
    'form-love-scale': 'Apreciación',
    'form-image-response': 'Respuesta con Imagen'
  }
}
